document.addEventListener('DOMContentLoaded', async function () {
  const wrapper = document.querySelector('.case-product-wrapper');
  const sectionRoot = wrapper ? wrapper.closest('[data-section-id]') : null;
  const sectionId = sectionRoot ? sectionRoot.dataset.sectionId : '';
  const baseUrl = window.location.pathname;
  const tbody = wrapper ? wrapper.querySelector('tbody') : null;
  const initialScript = document.getElementById('case-product-json');
  if (!wrapper || !tbody || !initialScript) return;
  const showSpecColumn = wrapper.dataset.showSpecColumn !== 'false';

  let pageData;
  try {
    pageData = JSON.parse(initialScript.textContent);
  } catch (e) {
    console.error('Failed to parse case table JSON', e);
    return;
  }

  let products = Array.isArray(pageData.products) ? [...pageData.products] : [];
  if (pageData.pages > 1) {
    const promises = [];
    for (let p = 2; p <= pageData.pages; p++) {
      promises.push(
        fetch(`${baseUrl}?section_id=${sectionId}&page=${p}`)
          .then((res) => res.text())
          .then((html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const script = doc.getElementById('case-product-json');
            if (!script) return [];
            return JSON.parse(script.textContent).products || [];
          })
          .catch((err) => {
            console.error('Failed to fetch page', p, err);
            return [];
          })
      );
    }
    const results = await Promise.all(promises);
    results.forEach((items) => {
      products = products.concat(items);
    });
  }

  function parseDimensions(dimStr) {
    function parseNumber(str) {
      if (!str) return null;
      let s = str.replace(/"/g, '').replace(/'/g, '').trim();
      const spaceIdx = s.indexOf(' ');
      if (spaceIdx !== -1) {
        const whole = parseFloat(s.substring(0, spaceIdx));
        const fracStr = s.substring(spaceIdx + 1);
        if (fracStr.indexOf('/') !== -1) {
          const fParts = fracStr.split('/');
          const frac = (parseFloat(fParts[0]) || 0) / (parseFloat(fParts[1]) || 1);
          return (whole || 0) + frac;
        }
      } else if (s.indexOf('/') !== -1) {
        const fParts = s.split('/');
        return (parseFloat(fParts[0]) || 0) / (parseFloat(fParts[1]) || 1);
      }
      return parseFloat(s) || null;
    }

    const parts = String(dimStr || '').toLowerCase().split('x');
    return {
      l: parseNumber(parts[0]),
      w: parseNumber(parts[1]),
      h: parseNumber(parts[2]),
    };
  }

  products.sort((a, b) => {
    const aDim = parseDimensions(a.dimensions_display || '');
    const bDim = parseDimensions(b.dimensions_display || '');
    if ((aDim.l || 0) !== (bDim.l || 0)) return (aDim.l || 0) - (bDim.l || 0);
    if ((aDim.w || 0) !== (bDim.w || 0)) return (aDim.w || 0) - (bDim.w || 0);
    return (aDim.h || 0) - (bDim.h || 0);
  });

  // Flatten products+variants into individual row items
  const rowItems = [];
  products.forEach((prod) => {
    (prod.variants || []).forEach((variant) => {
      rowItems.push({ prod, variant });
    });
  });

  function buildRowHtml(item) {
    const prod = item.prod;
    const variant = item.variant;
    const isAvailable = !!variant.available;
    const sku = variant.sku || variant.title || variant.id;
    const units = parseInt(variant.units_per_case, 10) || 1;
    const bundleSize = parseInt(variant.bundle_size, 10) || units || 1;
    const increment = parseInt(variant.increment, 10) || bundleSize || 1;
    const optionValues = [variant.option1, variant.option2, variant.option3]
      .filter((v) => v && v !== 'Default Title')
      .join(' / ');
    // Fulfillment tier badge: next-day tag = stocked in Utah, otherwise ships and delivers in 4-5 business days
    const tierBadge = prod.tier1
      ? '<span class="boxt-tier boxt-tier--stocked">Stocked in Utah</span>'
      : '<span class="boxt-tier boxt-tier--ships">Delivers in 4&ndash;5 business days</span>';
    let rowHtml = `<tr class="variant-row ${!isAvailable ? 'variant-unavailable' : ''}">`;
    rowHtml += `<td class="col-sku"><a href="${prod.url || variant.url || '#'}" class="variant-link"><strong>${sku}</strong></a>${tierBadge}</td>`;
    rowHtml += `<td class="col-dimensions"><strong>${prod.dimensions_display || '-'}</strong></td>`;
    if (showSpecColumn) {
      rowHtml += `<td class="col-variant">${optionValues || '-'}</td>`;
    }
    rowHtml += `<td class="col-units">${units}</td>`;
    rowHtml += `<td class="col-price"><span class="price-value">${variant.price_formatted}</span></td>`;
    rowHtml += `<td class="col-add"><div class="add-form-wrapper">`;
    rowHtml += `<input type="number" class="quantity-input" min="${bundleSize}" step="${increment}" value="${bundleSize}" data-bundle-size="${bundleSize}" data-increment="${increment}" aria-label="Quantity">`;
    rowHtml += `<button type="button" class="btn-add-cart" data-variant-id="${variant.id}" ${!isAvailable ? 'disabled' : ''}>${isAvailable ? 'Add' : 'Out'}</button>`;
    rowHtml += `</div></td></tr>`;
    return rowHtml;
  }

  function attachCaseEvents() {
    document.querySelectorAll('.case-product-table .quantity-input').forEach((input) => {
      input.addEventListener('change', function () {
        const min = parseInt(this.dataset.bundleSize, 10) || 1;
        const step = parseInt(this.dataset.increment, 10) || 1;
        let val = parseInt(this.value, 10);
        if (isNaN(val) || val < min) val = min;
        const remainder = (val - min) % step;
        if (remainder !== 0) val = val - remainder + step;
        this.value = val;
      });
    });

    document.querySelectorAll('.case-product-table .btn-add-cart').forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const formWrap = this.closest('.add-form-wrapper');
        const input = formWrap.querySelector('.quantity-input');
        const quantity = parseInt(input.value, 10);
        const variantId = this.dataset.variantId;
        if (!quantity || quantity <= 0) return;

        const properties = {};
        if (input.dataset.bundleSize) properties._bundle_size = String(input.dataset.bundleSize);
        if (input.dataset.increment) properties._increment = String(input.dataset.increment);

        const originalText = this.innerText;
        this.innerText = '...';
        this.disabled = true;

        const formData = {
          items: [{ id: variantId, quantity: quantity, properties: properties }],
          sections: 'cart-icon-bubble',
          sections_url: window.location.pathname,
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status === 422) {
              alert(data.description);
              return;
            }
            const cartIconBubble = document.getElementById('cart-icon-bubble');
            if (cartIconBubble && data.sections && data.sections['cart-icon-bubble']) {
              const htmlDoc = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
              const section = htmlDoc.querySelector('.shopify-section');
              cartIconBubble.innerHTML = section ? section.innerHTML : data.sections['cart-icon-bubble'];
            }
            document.dispatchEvent(new CustomEvent('cart:openDropdown'));
          })
          .catch((err) => {
            console.error('Fetch error:', err);
            alert('Failed to add to cart (Network Error)');
          })
          .finally(() => {
            this.innerText = originalText;
            this.disabled = false;
          });
      });
    });

    document.querySelectorAll('.case-product-table .variant-row').forEach((row) => {
      const tds = row.querySelectorAll('td');
      row.addEventListener('mouseenter', function () {
        tds.forEach((td) => td.classList.add('cell-hovered'));
      });
      row.addEventListener('mouseleave', function () {
        tds.forEach((td) => td.classList.remove('cell-hovered'));
      });
    });
  }

  function renderRows(items) {
    let html = items.map(buildRowHtml).join('');
    if (!html) {
      const colspan = showSpecColumn ? 6 : 5;
      html = `<tr><td colspan="${colspan}" style="text-align: center; padding: 2rem;">No linked case products found.</td></tr>`;
    }
    tbody.innerHTML = html;
    attachCaseEvents();
  }

  // Mobile: cap long tables to a first page + "Show all" button (Phase 3.3)
  const MOBILE_LIMIT = 20;
  let mobileExpanded = false;

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function showAllRowsButton(total) {
    let btn = document.getElementById('btn-show-all-sizes');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.id = 'btn-show-all-sizes';
      btn.className = 'btn-show-all-sizes';
      wrapper.insertAdjacentElement('afterend', btn);
      btn.addEventListener('click', function () {
        mobileExpanded = true;
        renderRowsLimited(rowItems);
      });
    }
    btn.textContent = 'Show all sizes';
    btn.style.display = '';
  }

  function hideAllRowsButton() {
    const btn = document.getElementById('btn-show-all-sizes');
    if (btn) btn.style.display = 'none';
  }

  function renderRowsLimited(items) {
    if (isMobileViewport() && !mobileExpanded && items.length > MOBILE_LIMIT) {
      renderRows(items.slice(0, MOBILE_LIMIT));
      showAllRowsButton(items.length);
    } else {
      renderRows(items);
      hideAllRowsButton();
    }
  }

  renderRowsLimited(rowItems);
});
